import isotipo from "@/assets/isotipo.svg";
import logotipo from "@/assets/logotipo.svg";

const sources = { isotipo, logotipo };

/**
 * Renders the brand svg as a CSS mask so it can be tinted with any Tailwind
 * background colour (the source files are hard-coded white).
 */
export default function BrandMark({
  variant = "isotipo",
  position = "center",
  className = "",
  fadeFromBottom = false,
}: {
  variant?: keyof typeof sources;
  position?: string;
  className?: string;
  /** Layers a bottom-to-middle gradient onto the shape mask so the mark dissolves toward its base. */
  fadeFromBottom?: boolean;
}) {
  // Vite inlines these small svgs as data URIs, so the url() must stay quoted.
  const url = `url(${JSON.stringify(sources[variant])})`;
  const fadeGradient =
    "linear-gradient(to top, transparent 0%, black 50%, black 100%)";

  const maskImage = fadeFromBottom ? `${url}, ${fadeGradient}` : url;

  return (
    <span
      aria-hidden
      className={`block ${className}`}
      style={{
        maskImage,
        WebkitMaskImage: maskImage,
        maskSize: fadeFromBottom ? "contain, 100% 100%" : "contain",
        WebkitMaskSize: fadeFromBottom ? "contain, 100% 100%" : "contain",
        maskRepeat: "no-repeat",
        WebkitMaskRepeat: "no-repeat",
        maskPosition: fadeFromBottom ? `${position}, center` : position,
        WebkitMaskPosition: fadeFromBottom ? `${position}, center` : position,
        ...(fadeFromBottom
          ? {
              maskComposite: "intersect",
              WebkitMaskComposite: "source-in",
            }
          : {}),
      }}
    />
  );
}
